import pick from "lodash/pick";
import { havePermission } from "../../permissions";
import LAYERS_PERMISSIONS from "../../permissions/Layers.json";
import { selectedPolygonTypes } from "../Common/Constants";
import Functions from "../Common/Functions";
import { isEmpty } from "lodash";

const { getLegend } = Functions;

const { whiteSpace_density } = selectedPolygonTypes;

const WhiteSpaceColors = {
	"": "#FFFFFF11",

	"Partially Covered": "#FF88A1",

	Whitespace: "#D3D3D3",

	"Completely Covered": "#4AF25A"
};
const getAllFlags = ({ data }) => {
	if (isEmpty(data)) return [];
	let allFlags = [];
	if (Array.isArray(data))
		for (let polygon of data) {
			const { flag } = polygon;
			if (!allFlags.includes(flag)) allFlags.push(flag);
		}
	allFlags = Array.from(new Set([...allFlags])).filter(Boolean);
	return allFlags;
};

const getWhiteSpaceDensityLegends = ({ data, legendHandler }) => {
	if (!havePermission(LAYERS_PERMISSIONS.LAYER_WHITE_SPACE_DENSITY_LEGENDS)) return {};

	const legends = [];
	let allFlags = [];
	if (isEmpty(allFlags) && !isEmpty(data)) {
		allFlags = getAllFlags({ data });
		if (isEmpty(allFlags)) {
			return { legends: [] };
		}
	}
	allFlags.forEach(value => {
		legends.push(
			getLegend({
				text: `${value}`,
				color: WhiteSpaceColors[value] || "#FF000077",
				onClick: () => {
					legendHandler(value);
				}
			})
		);
	});
	return { legends };
};
const getWhiteSpaceDensityPolygons = locations => {
	return {
		polygons: locations.map((obj, ind) => {
			const { flag, popular_times, population, sec, motor_sports_population } = obj;
			return {
				id: ind,
				_id: ind,
				coordinates: obj.coordinates,
				style: {
					fillColor: WhiteSpaceColors[flag] || "#FF000077",
					strokeColor: "#00000055",
					zindex: 10
				},
				filterData: { flag, popular_times, population, sec, motor_sports_population },

				polygonClick: true,
				type: whiteSpace_density
			};
		})
	};
};

const WhiteSpaceDensityService = {
	all: ({ locations, legendHandler }) => {
		return {
			...pick(getWhiteSpaceDensityPolygons(locations), ["polygons"]),
			...getWhiteSpaceDensityLegends({ data: locations, legendHandler })
		};
	},
	polygons: ({ locations }) => {
		return pick(getWhiteSpaceDensityPolygons(locations), ["polygons"]);
	}
};

export default WhiteSpaceDensityService;
export { getWhiteSpaceDensityPolygons };
